import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Regions/hooks/useRegion.ts
function useRegion(args, opts = {}) {
	const { call, data, error, isCalling } = useRPC(RPCs.Regions.GetRegionProfile.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.regionId
	});
	return {
		data,
		error,
		loading: isCalling,
		refresh: call
	};
}
export { useRegion };

//# sourceMappingURL=useRegion.js.map